import { Table } from "antd";
import { EditOutlined, WarningOutlined, StopOutlined } from "@ant-design/icons";
import { get, toString } from "lodash";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { paginationDefaults } from "../../../utils/properties";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Filter from "../../../components/functional_components/Filter/Filter";
import { useFormik } from "formik";
import { buildQueryString, showError } from "../../../utils/utilities";
import { setFilters } from "../../../redux/ducks/Filters";
import { setLoading } from "../../../redux/ducks/Loading";
import OrderProposal from "../../../services/api/OrderProposal";

const SalDeclaration = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const filters = useSelector((state) => state.FiltersDuck.filters);
  const [state, setState] = useState({
    tableContent: [],
    pagination: {
      currentPage: paginationDefaults.page,
      size: paginationDefaults.size,
      totalItems: paginationDefaults.totalItems,
    },
  });
  useEffect(() => {
    const queryString = buildQueryString(filters.obj, { status: "OPEN" });
    dispatch(setFilters(queryString));
    dataList(queryString.string);
  }, []);
  const dataList = async (queryString) => {
    dispatch(setLoading(true));
    const orders = await OrderProposal.listOrders(queryString);
    if (!orders.error && orders.data) {
      orders.data.forEach((cc, i) => {
        cc.key = i; // This is necessary to remove warning in console for unique key row
      });
      setState((prevState) => ({
        ...prevState,
        tableContent: get(orders, "data", []),
        pagination: {
          currentPage: orders.currentPage ? orders.currentPage + 1 : paginationDefaults.page,
          size: get(orders, "pageSize", paginationDefaults.size),
          totalItems: get(orders, "totalItems", paginationDefaults.totalItems),
        },
      }));
    } else {
      showError(get(orders, "error.messageCode", "ER000"));
    }
    dispatch(setLoading(false));
  };
  const formikFilter = useFormik({
    initialValues: {
      status: filters.obj.status ? filters.obj.status : null,
      supplierName: filters.obj.supplierName ? filters.obj.supplierName : null,
    },
    enableReinitialize: true,
    onSubmit: (values) => {
      // When I search, I start my page to 0
      values["page"] = 0;
      const queryString = buildQueryString(filters.obj, values);
      dispatch(setFilters(queryString));
      dataList(queryString.string);
    },
  });
  const resetFilter = () => {
    const queryString = buildQueryString(
      { page: toString(paginationDefaults.page - 1), size: toString(paginationDefaults.size) },
      {}
    );
    dispatch(setFilters(queryString));
    dataList(queryString.string);
  };
  const fieldsFilter = [
    {
      type: "select",
      dataSelect: [
        {
          label: t("salDeclaration.filter.all"),
          value: "",
        },
        {
          label: t("salDeclaration.filter.completed"),
          value: "COMPLETED",
        },
        {
          label: t("salDeclaration.filter.open"),
          value: "OPEN",
        },
      ],
      isRequired: false,
      id: "status",
      name: "status",
      value: formikFilter.values.status,
      label: t("salDeclaration.filter.status"),
      onChange: formikFilter.handleChange("status"),
      onBlur: formikFilter.handleBlur("status"),
    },
    {
      type: "input",
      isRequired: false,
      id: "supplierName",
      name: "supplierName",
      value: formikFilter.values.supplierName,
      label: t("projects.filter.supplierName"),
      onChange: formikFilter.handleChange,
      onBlur: formikFilter.handleBlur,
    },
  ];
  const columns = [
    {
      title: t("salDeclaration.table.numberOrder"),
      dataIndex: "id",
      key: "id",
      render: (value, item) => (
        <div>
          {item.statusOrder === "BLOCKED" && <StopOutlined className="PFred mr-10" />}
          {item.userSupportPm === null ? <WarningOutlined key={item.id} className="PFred" /> : ""}
          {value}
        </div>
      ),
    },
    {
      title: t("salDeclaration.table.statusOrder"),
      dataIndex: "statusOrder",
      key: "statusOrder",
    },
    {
      title: t("salDeclaration.table.supplierCode"),
      dataIndex: "supplierId",
      key: "supplierId",
    },
    {
      title: t("salDeclaration.table.supplierName"),
      dataIndex: "supplierName",
      key: "supplierName",
    },
    {
      title: "",
      dataIndex: "",
      key: "x",
      width: 50,
      render: (_, record) => {
        return (
          <div className="actions-container">
            <div onClick={() => navigate(record.id)}>
              <EditOutlined className="icon-medium" />
            </div>
          </div>
        );
      },
    },
  ];
  return (
    <>
      <Filter formikForm={formikFilter} fields={fieldsFilter} onReset={resetFilter} />
      <Table
        columns={columns}
        dataSource={state.tableContent}
        size="small"
        pagination={{
          showSizeChanger: false,
          current: state.pagination.currentPage,
          pageSize: state.pagination.size,
          total: state.pagination.totalItems,
          onChange: (page, pageSize) => {
            const queryString = buildQueryString(filters.obj, { page: toString(page - 1), size: pageSize });
            dispatch(setFilters(queryString));
            setState((prevState) => ({
              ...prevState,
              pagination: {
                currentPage: page,
                size: pageSize,
                totalItems: state.pagination.totalItems,
              },
            }));
            dataList(queryString.string);
          },
        }}
      />
    </>
  );
};

export default SalDeclaration;
